import { gql } from '@moonpig/web-core-graphql'

const PRODUCT_VARIANT_FIELDS_FRAGMENT = gql`
  fragment ProductVariantFields on ProductVariant {
    key
    title
    subtitle
    inStock
    sku
    minimumQuantity
    price {
      centAmount
      currencyCode
      fractionDigits
    }
    fullPrice {
      centAmount
      currencyCode
      fractionDigits
    }
    discountedPercentage
    dimensions {
      description
    }
    capabilities {
      video
    }
  }
`

const PRODUCT_FIELDS_FRAGMENT_WITHOUT_CLICK_RANK = gql`
  ${PRODUCT_VARIANT_FIELDS_FRAGMENT}

  fragment ProductFieldsWithoutClickRank on Product {
    id
    title
    description
    slug
    dependencies
    customisable
    editableTextFieldCount
    photoUploadCount
    isLandscape
    category {
      id
      slug
      name
      department
    }
    range {
      key
    }
    rating {
      count
      score
    }
    masterVariant {
      ...ProductVariantFields
      productImages {
        mainImage {
          medium {
            jpgUrl
          }
        }
        images {
          small {
            jpgUrl
          }
          medium {
            jpgUrl
          }
          large {
            jpgUrl
          }
        }
      }
    }
    variants {
      ...ProductVariantFields
    }
    hasAugmentedReality
    productPills {
      displayLabel
      displayVariant
    }
    primaryProductPill {
      displayLabel
      displayVariant
    }
    isSponsored
  }
`

export const PRODUCT_FIELDS_FRAGMENT = gql`
  ${PRODUCT_FIELDS_FRAGMENT_WITHOUT_CLICK_RANK}

  fragment ProductFields on Product {
    ...ProductFieldsWithoutClickRank
    clickRankDocumentCount
  }
`
